import {
  ActiveProcessStoreModel,
  InvoiceCycleProcessStoreModel,
  GenericProcessStoreModel
} from '../store.model'

// Action Types
export const ADD_ACTIVE_PROCESS = 'ADD_ACTIVE_PROCESS'
export const REMOVE_ACTIVE_PROCESS = 'REMOVE_ACTIVE_PROCESS'
export const UPDATE_PROCESS_STATUS = 'UPDATE_PROCESS_STATUS'

// Action Interfaces
export interface AddActiveProcessAction {
  type: typeof ADD_ACTIVE_PROCESS
  payload: ActiveProcessStoreModel
}

export interface RemoveActiveProcessAction {
  type: typeof REMOVE_ACTIVE_PROCESS
  payload: {
    processId: string
  }
}

export interface UpdateProcessStatusAction {
  type: typeof UPDATE_PROCESS_STATUS
  payload: {
    processId: string
    newStatus: any
  }
}

export type ProcessingActionTypes =
  | AddActiveProcessAction
  | RemoveActiveProcessAction
  | UpdateProcessStatusAction

// Action Creators

/**
 * Agregar un proceso de Invoice Cycle
 */
export const addInvoiceCycleProcess = (
  executionCycleId: number,
  currentStatus: any,
  additionalState?: any,
  cycleName?: string
): AddActiveProcessAction => {
  const processId = `process-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

  const process: InvoiceCycleProcessStoreModel = {
    processId,
    processType: 'invoiceCycle',
    executionCycleId,
    currentStatus,
    cycleName,
    invoiceCycleId: additionalState?.invoiceCycleId,
    additionalState,
    startedAt: new Date()
  }

  return {
    type: ADD_ACTIVE_PROCESS,
    payload: process
  }
}

/**
 * Agregar un proceso genérico
 */
export const addGenericProcess = (currentStatus: any, data: any): AddActiveProcessAction => {
  const processId = `process-${Date.now()}-${Math.random().toString(36).substr(2, 9)}`

  const process: GenericProcessStoreModel = {
    processId,
    processType: 'generic',
    currentStatus,
    data,
    startedAt: new Date()
  }

  return {
    type: ADD_ACTIVE_PROCESS,
    payload: process
  }
}

export const removeActiveProcess = (processId: string): RemoveActiveProcessAction => ({
  type: REMOVE_ACTIVE_PROCESS,
  payload: { processId }
})

export const updateProcessStatus = (
  processId: string,
  newStatus: any
): UpdateProcessStatusAction => ({
  type: UPDATE_PROCESS_STATUS,
  payload: { processId, newStatus }
})
